export const FOOTER_CLASSNAME = 'FOOTER_CLASSNAME';